import axios from "axios";
import { API_BASE_URL } from "../constant";


const goldRate=[
    {
        "karat_24(995)": {
            "price_per_gram": 9765,
            "trend": "STABLE",
            "price_diff_per_gram": 0,
            "yesterday": 9765,
            "last_7_days": 9640,
            "last_month": 8898,
            "last_year": 7891
        }
    },
    {
        "karat_22": {
            "price_per_gram": 8945,
            "trend": "STABLE",
            "price_diff_per_gram": 0,
            "yesterday": 8945,
            "last_7_days": 8830,
            "last_month": 8151,
            "last_year": 7238
        }
    },
    {
        "karat_18": {
            "price_per_gram": 7324,
            "trend": "STABLE",
            "price_diff_per_gram": 0,
            "yesterday": 7324,
            "last_7_days": 7230,
            "last_month": 6674,
            "last_year": 5919
        }
    },
    {
        "karat_14": {
            "price_per_gram": 5693,
            "trend": "STABLE",
            "price_diff_per_gram": 0,
            "yesterday": 5693,
            "last_7_days": 5620,
            "last_month": 5188,
            "last_year": 4617
        }
    },
    {
        "karat_24(999)": {
            "price_per_gram": 9795,
            "trend": "STABLE",
            "price_diff_per_gram": 0,
            "yesterday": 9795,
            "last_7_days": 9670,
            "last_month": 8928,
            "last_year": 7926
        }
    }
]


export const createOldGold=async(payload)=>{

const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${API_BASE_URL}/gold_receipt`,
    headers: {
      'Content-Type': 'application/json',
    //   'Authorization': 'Bearer 9tcpn4uq9my8ymfj0qbdsscld9pqzlta',
    },
    withCredentials: true,
    data: payload,
  };

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    console.error('Error creating POS order:', error);
    return error; 
  }
}

export const GetGoldRate=async()=>{
    
    // const config = {
    //     method: 'GET',
    //     maxBodyLength: Infinity,
    //     url: 'https://api.hyperready.tech/admin/api/microsite/getgoldrate',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     //   'Authorization': 'Bearer 9tcpn4uq9my8ymfj0qbdsscld9pqzlta',
    //     },
    //     withCredentials: true,
    //     // data: payload,
    //   };
    
      try {
        // const response = await axios.request(config);        
        return goldRate
      } catch (error) {
        console.error('Error creating POS order:', error);
        throw error; 
      }
}



export const GetOldGoldList=async(payload)=>{
  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${API_BASE_URL}/gold_exchange_receipts`,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
    data: payload,
  };

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    console.error('Error creating POS order:', error);
    return error; 
  }
}